<template>
    <div class="ur-switch ur-input" :class="rootClass" @click.stop="toggleValue">
        <div class="ur-switch__circle"></div>
        <div v-if="labeled" class="ur-switch__text"> {{ innerText }} </div>
    </div>
</template>

<script>
    // ur-switch 설정에 따라 토글값에 따른 label 값을 나타내줍니다
    // #Shows label value according to toggle value according to ur-switch setting
    export default {
        name: 'ur-switch',
        model: { /*same as default*/
            event: 'input', prop: 'value'
        },
        inject: {
            urInput: {from:'urInput', default: () => undefined}
        },
        props: {
            // $ver: v0.1.0
            // $v-model
            // v-model로 바인딩되는 값으로, 스위치의 값과 연계됩니다. positiveValue/negativeValue 속성으로 지정한 값을 가집니다.
            // #The value bound to v-model, associated with the value of the switch. It has the value specified by the positiveValue / negativeValue property.
            // $default: true
            // $tags: IDE
            value: {
                type: [Boolean, String],
                default: true,
            },
            // $ver: v0.1.0
            // 토글 되었을 때 값을 지정합니다.
            // #Specifies the value when toggled.
            // $default: true
            positiveValue: {
                type: [Boolean, String],
                default: true
            },
            // $ver: v0.1.0
            // 토글 해제 되었을 때 값을 지정합니다.
            // #Specifies the value when toggled off.
            // $default: false
            negativeValue: {
                type: [Boolean, String],
                default: false
            },
            // $ver: v0.2.0
            // 스위치 크기를 결정합니다. 'small', 'medium','large' 세 가지 중 하나를 입력해야 합니다.
            // #The size You must enter one of three types: small or medium or large.
            // $tags: IDE
            size:  {type: String, default: undefined},
            // $ver: v0.1.0
            // 컴포넌트 크기를 Large 사이즈로 설정합니다.
            // #Set the component size to Large.
            // $default: false
            large: {
                type: Boolean,
                default: false
            },
            // $abbr: large
            lg:{type:Boolean},
            // $ver: v0.1.2
            // 컴포넌트 크기를 Medium 사이즈로 설정합니다.
            // #Set the component size to Medium size.
            // $default: false
            medium: {
                type: Boolean,
                default: false
            },
            // $abbr: medium
            md:{type:Boolean},
            // $ver: v0.1.2
            // 컴포넌트 크기를 Small 사이즈로 설정합니다.
            // #Set the component size to Small size.
            // $default: false
            small: {
                type: Boolean,
                default: false
            },
            // $abbr: large
            sm:{type:Boolean},
            // $ver: v0.1.0
            // 비활성화 상태로 변경합니다.
            // #Change to inactive state.
            // $default: false
            // $tags: IDE
            disabled: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.0
            // ON/OFF 문자를 토글/토글해제 시 표시합니다.
            // #ON / OFF Displays characters when toggled / toggled.
            // $default: false
            // $tags: IDE
            labeled: {
                type: Boolean,
                default: false
            },
        },
        data() {return{
            default:{
                size: 'medium'
            }
        }},
        computed: {
            $_size() {
                if(this.size ==='large' ||this.large || this.lg) {return 'large'}
                if(this.size ==='medium' || this.medium || this.md) {return 'medium'}
                if(this.size ==='small' ||this.small || this.sm) {return 'small'}
                if(this.urInput) {return this.urInput.size}
                return this.default.size;
            },
            rootClass() {
                let rtn = [];
                rtn.push('ur-switch--'+this.$_size);
                if(this.labeled){rtn.push('ur-switch--labeled');}
                if(this.disabled){rtn.push('ur-switch--disabled');}
                if(this.value===this.negativeValue) {rtn.push('ur-switch--off');}
                else {rtn.push('ur-switch--on');}
                return rtn;
            },
            innerText() {
                return (this.value===this.positiveValue ? 'ON' : 'OFF');
            },
        },
        methods: {
            // @vuese
            // $ver: v0.1.0
            // $return: N/A
            // 토글/토글해제 처리합니다.
            // #Toggles / untoggles.
            toggleValue() {
                if (!this.disabled) {
                    if(this.value===this.positiveValue) {
                        // $ver: v0.1.0
                        // $return: updated value
                        // 토글/토글해제 될 때, 변경된 값을 파라미터로 이벤트를 발생시킵니다.
                        // #When toggled / untoggled, triggers an event with the changed value as a parameter.
                        this.$emit('input', this.negativeValue);
                    } else {
                        this.$emit('input', this.positiveValue);
                    }
                }
            }
        }
    };

</script>
